module.exports = __webpack_public_path__ + "img/NL323.9da89097.png";